import React, {useEffect, useRef} from 'react';

/**
 * Kleines barrierearmes Meldungsmodal als Ersatz für JavaScript-alert().
 * Es fokussiert die Schließen-Schaltfläche und unterstützt Escape sowie einen
 * Klick auf den abgedunkelten Hintergrund.
 */
export default function Modal({message, closeLabel, onClose}) {
  const closeRef = useRef(null);
  useEffect(() => {
    if (!message) return undefined;
    closeRef.current?.focus();
    const closeOnEscape = (event) => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [message, onClose]);
  if (!message) return null;
  return (
    <div className="pf-modal" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <div className="pf-modal__dialog" role="dialog" aria-modal="true" aria-live="assertive">
        <p>{message}</p>
        <button type="button" className="pf-button pf-button--primary" onClick={onClose} ref={closeRef}>{closeLabel}</button>
      </div>
    </div>
  );
}
